// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble-buttom[data-v-4740ffd4]{border-radius:.375rem;margin-top:.5rem;margin-bottom:.5rem;padding:.75rem;position:relative;background-color:#f3f4f6}", ""]);
// Exports
module.exports = exports;
